import { render, staticRenderFns } from "./projectOrderInfo.vue?vue&type=template&id=722ec270&scoped=true"
import script from "./projectOrderInfo.vue?vue&type=script&lang=js"
export * from "./projectOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./projectOrderInfo.vue?vue&type=style&index=0&id=722ec270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722ec270",
  null
  
)

export default component.exports